"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var getRegionsByCountry = function (country) {
    return index_1.regionsByCountry[country];
};
exports.default = getRegionsByCountry;
